import { render, staticRenderFns } from "./MyBadges.vue?vue&type=template&id=cda4aad8&scoped=true"
import script from "./MyBadges.vue?vue&type=script&lang=js"
export * from "./MyBadges.vue?vue&type=script&lang=js"
import style0 from "./MyBadges.vue?vue&type=style&index=0&id=cda4aad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda4aad8",
  null
  
)

export default component.exports